import { FC } from 'react';
import { IncorrectTimeNote } from '../../../utils/model';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

interface IncorrectTimeNotesTableProps {
  incorrectNotes: IncorrectTimeNote[];
}

export const IncorrectTimeNotesTable: FC<IncorrectTimeNotesTableProps> = ({
  incorrectNotes,
}) => {
  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>shortIssue</TableCell>
              <TableCell>Project</TableCell>
              <TableCell align="right">Author</TableCell>
              <TableCell align="right">Note Created</TableCell>
              <TableCell align="right">Note Spend</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {incorrectNotes.map((row) => (
              <TableRow
                key={`${row.shortIssue.iid}-${row.noteId}-${row.shortIssue.project.fullPath}`}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  <a
                    href={`${row.shortIssue.webUrl}#note_${row.noteId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {row.shortIssue.title}
                  </a>
                </TableCell>
                <TableCell align="left">
                  <a
                    href={row.shortIssue.project.webUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {row.shortIssue.project.name}
                  </a>
                </TableCell>
                <TableCell align="right">{row.author?.name ?? '?'}</TableCell>
                <TableCell align="right">{row.createdAt.toLocaleDateString()}</TableCell>
                <TableCell align="right">{row.spentAt.toLocaleDateString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
